import React, { Component } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';
import CreateGlobalSnippetForm from '../components/CreateGlobalSnippetForm';
import axios from 'axios';
import { Panel, Col, Row, Button, FormControl, Form } from 'react-bootstrap';
import PlainPanel from '../components/PlainPanel';
import config from '../config';
import qs from 'qs';
import { Link } from 'react-router-dom';

import './CreateGlobalSnippet.css';

class CreateGlobalSnippet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userIsAuthorized: props.userIsAuthorized,
            organisation: { planType: "PREMIUM"}
        };
    }


    loadOrganisationInformation() {
        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation: response.data.organisation
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    componentDidMount() {
        this.loadOrganisationInformation();
    }

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'CreateGlobalSnippet.title'
        )}`;

        const { uuid, playerUUID, pageUUID } = this.props.match.params;

        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;

        return (
            <div className="CreateGlobalSnippet">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <div className="row">
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('CreateGlobalSnippet.title')}
                                </h1>
                                <ol className="breadcrumb">
                                    <React.Fragment>
                                        <li>
                                            <i className="fa fa-tachometer-alt" />{' '}
                                            <Link to={`/organisations/${uuid}`}>
                                                {t('Dashboard.title')}
                                            </Link>
                                        </li>
                                        <li>
                                            <i className="fa fa-puzzle-piece" />{' '}
                                            <Link
                                                to={`/organisations/${uuid}/snippets`}
                                            >
                                                {t(
                                                    'SideNavigation.globalsnippets'
                                                )}
                                            </Link>
                                        </li>
                                        <li className="active">
                                            <i className="fa fa-edit" />{' '}
                                            {t('CreateGlobalSnippet.title')}
                                        </li>{' '}
                                    </React.Fragment>
                                </ol>

                                <PlainPanel>
                                    <CreateGlobalSnippetForm
                                        userIsAuthorized={this.state.userIsAuthorized}
                                        user={this.props.user}
                                        organisation={this.state.organisation}
                                        uuid={uuid}
                                        pageUUID={pageUUID}
                                    />
                                </PlainPanel>
                            </Col>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(CreateGlobalSnippet);
